import { DocumentRequirementItem } from 'app/models/document-requirement/document-requirement-item.model';
import { DocusignEnvelope } from 'app/models/docusign/docusign-models';

export interface DocumentRequirements {
  remaining: RemainingDocumentRequirement[];
  satisfied: SatisfiedDocumentRequirement[];
}

export interface RemainingDocumentRequirement {
  documentCategory: DocumentCategory;
  source: DocumentSource;
  sourceId: number;
  timePeriod: string | null;
  isSatisfied: boolean;
  docusignEnvelope?: DocusignEnvelope;
}

export enum DocumentSource {
  LoanProductQuestion = 'loanProductQuestion',
  DocumentRequest = 'documentRequest',
  ApplicationModuleDocumentCategory = 'applicationModuleDocumentCategory',
}

export interface SatisfiedDocumentRequirement {
  documentCategory: DocumentCategory;
  timePeriod: string | null;
  documentId: number;
}

export interface DocumentCategory {
  id: string;
  name: string;
  timeClassification: string | null;
}

export interface DocumentRequest {
  publishTo: string;
  deliverTo: string;
  categoryId: string;
  year?: number | null;
  month?: number | null;
  name: string;
  description?: string;
}

export interface DocumentRequestPayload {
  documentRequirements: DocumentRequirementItem[];
  notifyBorrower?: boolean;
  noticeToBorrower?: string;
}

export interface DocumentRequirementRequest {
  noticeToBorrower?: string;
  notifyBorrower?: boolean;
  requirements: DocumentRequest[];
}

export interface DealDocumentRequirementOverride {
  id: number;
  dealId: number;
  loanProductQuestionId: number;
  userId: number;
  reason: string;
}
